import { minutesToMilliseconds } from 'date-fns'
import { useCallback } from 'react'

import { useFirebaseToken } from '@/hooks/useFirebaseUser/useFirebaseToken'
import { useFirebaseUser } from '@/hooks/useFirebaseUser/useFirebaseUser'
import authenticationService from '@/services/authentication/authentication'

import { useUsersServiceGetV1UsersMe } from '../client/queries'
import { GetV1UsersMeResponse } from '../client/requests'

export type UserType = GetV1UsersMeResponse

export const useMe = (enabled = true) => {
  const token = useFirebaseToken()
  const { isLoggedIn, reloadUser } = useFirebaseUser()

  const reloadUserIfIndividualsChanged = useCallback(
    async (newData: UserType, previousData?: UserType) => {
      if (!previousData || !newData) return newData

      if (previousData.individuals.length !== newData.individuals.length) {
        await reloadUser()
      }

      return newData
    },
    [reloadUser],
  )

  // reloadUserIfIndividualsChanged(data!, queryClient.getQueryData<UserType>(queryKey)),

  return useUsersServiceGetV1UsersMe(undefined, {
    enabled: enabled && !!token,
    refetchInterval: minutesToMilliseconds(60),
    refetchOnWindowFocus: 'always',
    retry: count => {
      if (isLoggedIn && count === 0) {
        reloadUser()

        return true
      }

      authenticationService.signOut()

      return false
    },
  })
}
